import React, { useState } from 'react'

import * as yup from 'yup'
import { Formik } from 'formik'
import { useNavigate } from 'react-router-dom'

import UIButton from '../../components/UI/UIButton'
import UICheckbox from '../../components/UI/UICheckBox'
import UITextInput from '../../components/UI/UITextInput'
import UIFieldError from '../../components/UI/UIFieldError'
import UIPasswordInput from '../../components/UI/UIPasswordInput'
import { Icon } from '../../components/Icon'
import { ReactComponent as LogoSvg } from '../../assets/svgs/logos/Logo.svg'
import { useAuth } from '../../context/AuthContext'
// import RECAPTCHA from 'react-google-recaptcha'  // Disabled for demo

const validationSchema = yup.object().shape({
  email: yup.string().required('Email address is required'),
})

const Login = () => {
  const { login } = useAuth()

  // const [captchaVal, setCaptchaVal] = useState<string | null>(null)  // Disabled for demo

  const navigate = useNavigate()
  const [isChecked, setIsChecked] = useState<boolean>(false)
  const [loading, setLoading] = useState(false)

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked)
  }

  return (
    <div className="min-h-screen bg-gray1 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="mx-5 sm:mx-auto sm:w-full sm:max-w-lg flex">
        <div className="flex gap-4 flex-1 ">
          <LogoSvg width={130} height={36} />
        </div>
      </div>

      <div className="mx-5 sm:mx-auto mt-8 sm:w-full sm:max-w-lg">
        <Formik
          enableReinitialize
          initialValues={{
            email: '',
            password: '',
          }}
          validationSchema={validationSchema}
          onSubmit={async (values) => {
            setLoading(true)

            try {
              await login(values.email, values.password)
              navigate('/home')
            } catch (error) {
              console.error('Login failed', error)
            } finally {
              setLoading(false)
            }
          }}
        >
          {({ handleSubmit, errors, handleChange, values, handleBlur }) => (
            <div className="bg-white py-10 px-4 shadow  rounded-[1rem] sm:px-10">
              <div className="flex flex-col py-2 gap-3 justify-center align-middle text-center  ">
                <p className="text-lg font-bold text-text2">
                  Let’s get you logged in
                </p>
                <p className="text-sm font-normal text-[#3487A2]">
                  Please fill out the following fields to login:
                </p>
              </div>
              <div className="mt-10">
                <div className="flex flex-col gap-5">
                  <div>
                    <UITextInput
                      error={errors?.email}
                      label={'Email*'}
                      value={values.email}
                      onChange={handleChange('email')}
                      onBlur={handleBlur('email')}
                      placeholder="Please enter your email"
                      iconName={'IconUserCircle'}
                    />
                    {errors.email ? (
                      <UIFieldError
                        className="mt-2"
                        errorMessage={errors.email}
                      />
                    ) : null}
                  </div>
                  <div>
                    <UIPasswordInput
                      // error={errors?.password}
                      label={'Password*'}
                      value={values.password}
                      onChange={handleChange('password')}
                      onBlur={handleBlur('password')}
                      placeholder="Please enter your password"
                      iconName={'IconLock'}
                    />
                    {/* {errors.password ? (
                        <UIFieldError
                          className="mt-2"
                          errorMessage={errors.password}
                        />
                      ) : null} */}
                  </div>
                </div>
                {/* RECAPTCHA temporarily disabled for demo
                <div className="container mx-auto mt-6 ml-3">
                  <RECAPTCHA
                    sitekey="6Le-ji8qAAAAAFZRviI0NotDk1ch6h4rysjykfEj"
                    onChange={(val: string | null) => {
                      setCaptchaVal(val)
                    }}
                  />
                </div>
                */}

                <div className="container mx-auto mt-6 ml-3">
                  <UICheckbox
                    label="Remember me"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                  />
                </div>
                <div className="container mx-auto my-8">
                  <UIButton
                    disabled={false}
                    loading={loading}
                    label={'Login'}
                    type="submit"
                    onClick={handleSubmit}
                  />
                </div>
                <div className="container mx-auto mt-10 flex">
                  <div className="flex-1">
                    <p
                      onClick={() => navigate('/password-reset')}
                      className="font-semibold text-sm text-left text-text1 hover:text-bluishGreen underline cursor-pointer"
                    >
                      Forgot password?
                    </p>
                  </div>
                  {/* <div>
                      <p
                        onClick={() => navigate('/verify-email')}
                        className="font-semibold text-sm text-right text-text1 hover:text-bluishGreen underline cursor-pointer"
                      >
                        Resend verification email
                      </p>
                    </div> */}
                </div>
              </div>
            </div>
          )}
        </Formik>

        <div className="sm:mx-auto w-full h-auto px-8 my-4 py-6 rounded-[1rem] gap-16 bg-gray2">
          <div className="flex gap-3 items-center">
            <Icon
              name={'IconCheckMonogram'}
              width={16}
              height={16}
              strokeWidth={1}
            />
            <div
              className="cursor-pointer"
              onClick={() => navigate('/privacy-policy')}
            >
              <p className="font-medium text-xs text-text1">Privacy Policy</p>
            </div>
            <div
              className="cursor-pointer"
              onClick={() => navigate('/terms-condiditions')}
            >
              <p className="font-medium text-xs text-text1">
                Terms & Conditions
              </p>
            </div>
          </div>
          <div className="mt-4">
            <p className="font-medium text-xs text-text3">
              © 2025 Streamlearn Ltd. All rights reserved. 360 Safeguarding is
              a trading name of Streamlearn Ltd. Company No. 12180453.
              Registered office: Axis 19 Mallard Way, Riverside Business Park,
              Swansea Vale, Swansea, SA7 0AJ.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login
